import { EventCatalogFromKeys, EventType } from "../../../types";

export const PerformanceEventKeys = {
  ADMIN_PERFORMANCE_PAGE_VIEW: "admin-performance-page-view",
  ADMIN_PERFORMANCE_TAB_CHANGE: "admin-performance-tab-change",
  PERFORMANCE_CLIENT_EXPORT: "performance-client-export",
  PERFORMANCE_CLIENT_REFRESH: "performance-client-refresh",
  PERFORMANCE_CLIENT_SEARCH: "performance-client-search",
  PERFORMANCE_CLIENT_TABLE_SORT: "performance-client-table-sort",
  PERFORMANCE_CLIENT_TIMEFRAME_CHANGE: "performance-client-timeframe-change",
} as const;

export const PerformanceEventCatalog: EventCatalogFromKeys<
  typeof PerformanceEventKeys
> = {
  [PerformanceEventKeys.ADMIN_PERFORMANCE_PAGE_VIEW]: {
    description: "Admin viewed the performance page",
    eventType: EventType.PAGE_VIEW,
    id: PerformanceEventKeys.ADMIN_PERFORMANCE_PAGE_VIEW,
  },
  [PerformanceEventKeys.ADMIN_PERFORMANCE_TAB_CHANGE]: {
    description: "Admin changed tab in performance report tabs",
    eventType: EventType.INTERACTION,
    id: PerformanceEventKeys.ADMIN_PERFORMANCE_TAB_CHANGE,
  },
  [PerformanceEventKeys.PERFORMANCE_CLIENT_EXPORT]: {
    description: "User exported data in PerformanceClient",
    eventType: EventType.INTERACTION,
    id: PerformanceEventKeys.PERFORMANCE_CLIENT_EXPORT,
  },
  [PerformanceEventKeys.PERFORMANCE_CLIENT_REFRESH]: {
    description: "User refreshed data in PerformanceClient",
    eventType: EventType.INTERACTION,
    id: PerformanceEventKeys.PERFORMANCE_CLIENT_REFRESH,
  },
  [PerformanceEventKeys.PERFORMANCE_CLIENT_SEARCH]: {
    description: "User searched in PerformanceClient",
    eventType: EventType.FILTER,
    id: PerformanceEventKeys.PERFORMANCE_CLIENT_SEARCH,
  },
  [PerformanceEventKeys.PERFORMANCE_CLIENT_TABLE_SORT]: {
    description: "User sorted the performance table in PerformanceClient",
    eventType: EventType.INTERACTION,
    id: PerformanceEventKeys.PERFORMANCE_CLIENT_TABLE_SORT,
  },
  [PerformanceEventKeys.PERFORMANCE_CLIENT_TIMEFRAME_CHANGE]: {
    description: "User changed time frame in PerformanceClient",
    eventType: EventType.INTERACTION,
    id: PerformanceEventKeys.PERFORMANCE_CLIENT_TIMEFRAME_CHANGE,
  },
};
